import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import {
    Paper,
    FormControl,
    TextField,
    Select,
    MenuItem,
    Typography,
    FormGroup,
    Button
} from '@material-ui/core';
import axios from 'axios';
import Common from '../Common';
import SearchButton from './MessageLogSearchButton';
import ResetButton from './MessageLogResetButton';

const styles = (theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '95%',
        marginTop: '5px',
        justifyContent: 'center',
        minWidth: 1200
    },
    grid: {
        // border: `1px solid ${theme.palette.divider}`,
        margin: '0px auto',
        marginTop: '10px',
        border: '1px solid rgba(0, 0, 0, 0.5);',
        borderRadius: '5px',
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.secondary,
    },
    formControll: {
        margin: '0px 7px',
    },
    dateSelectStart: {
        margin: '0px',
    },
    dateSelectEnd: {
        margin: '0px auto 0px 0px',
    },
    controllLabel: {
        margin: '20px 0px 10px 20px',
    },
    fieldHover: {
        width: '375px',
        cursor: 'pointer',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#f5f5f5',
        },
    },
    conditionLeft: {
        width: '300px',
    },
    conditionRight: {
        width: '650px',
    },
    select: {
        margin: theme.spacing(1),
        width: '300px',
    },
    title:{
        marginTop: '30px'
    },
    johokubunList:{
        borderBottom: 'solid 1px #E0E0E0',
    },
    labelArea:{
        width: 120,
        textAlign: 'right',
        margin: '20px 30px 10px 0px',
    },
    selectKubunArea: {
        marginLeft: '10px',
        alignItems: 'center',
    },
    topSpace:{
        marginTop: '50px',
        margin: '20px 65px 10px 70px',
    },
    button: {
        //marginLeft: '30px',
        alignItems: 'center',
        justifyContent: 'center',
    },
    categorySelect:{
        margin: '15px auto 0px 0px',
    },
    state:{
        margin: '20px auto 0px 0px',
    },
    memo:{
        marginRight: 'auto',
    },
    requester:{
        margin: '0px 7px 0px 138px',
    },
    stateList:{
        borderBottom: 'solid 2px #FFF',
        height:'40px',
    },
    to: {
        marginRight: '40px',
        left: '20px',
        position: 'relative',
    },
    buttonSpace: {
        //right: '0',
        margin: '5px 100px 0px 0px',
    },
    flexGrow:{
        flexGrow: '1'
    },
    endFlg:{
        width:'100px'
    },
});

const stateFlg = [
    {
        stateName: '未回答',
        stateId: '0'
    },
    {
        stateName: 'はい',
        stateId: '1'
    },
    {
        stateName: 'いいえ',
        stateId: '2'
    }
];

const MessageLogSearch = withCookies((props) => {
    const { classes, setData, setPage, setFullTextDisplayFlg, availableAddress, setIsLoading, cookies} = props;
    const [requestStartDate, setRequsetStartDate] = React.useState('');
    const [requestEndDate, setRequsetEndDate] = React.useState('');
    const [categoryList, setCategoryList] = React.useState([]);
    const [displayCategory, setDisplayCategory] = React.useState('');
    const [selectCategory, setSelectCategory] = React.useState([]);
    const [chatTitle, setChatTitle] = React.useState('');
    const [addressNumber, setAddressNumber] = React.useState('');
    const [nickName, setNickName] = React.useState('');
    const [displayState, setDisplayState] = React.useState('');
    const [state, setState] = React.useState([]);
    const chatNameObj = cookies.get('COMMON_NAME_OBJ');
    const kubunName = chatNameObj !== undefined ? chatNameObj.KUBUN_NAME : 'チャットカテゴリ';
    const addressName = chatNameObj !== undefined ? chatNameObj.ADDRESS_NAME : '宛名番号';
    const userName = chatNameObj !== undefined ? chatNameObj.USER_NAME : 'ニックネーム';

    //-----------------------------------------------------------------
    //              ページに格納するデータの取得
    //-----------------------------------------------------------------
    function getChatData() {
        if(categoryList.length === 0){
            //TOKEN取得
            axios.post(
            `${Common.apiServerUrl()}/api/auth/token`,
                {},
                {
                    headers: {
                        'Authorization': 'Bearer ' + cookies.get('id_token')
                    },
                }
            )
            .then(Common.handleErrors)
            .then((Response) => {
                if (Response.success) {
                    cookies.set('token', Response.token, {
                        maxAge: 60 * 60 * 24 * 30, //30日間
                        httpOnly: false,
                        path: '/',
                        secure: true,
                    });

                    const jichitaiToken = cookies.get('x-jichitai-token');
                    const jichitaiId = cookies.get('x-jichitai-jichitaiid');
                    const supportedPersonId = cookies.get('supportedPersonId');

                    //-------------------------------------------
                    //プルダウンに表示する情報区分の取得 APIアクセス先(johoKubun.js)
                    //cookieに保存している職員番号でGetアクセスを行う
                    //-------------------------------------------
                    // -------------------------axios------------------------------
                    axios.get(
                        `${Common.apiServerUrl()}/api/counseling/getResponsibleKubun`,
                        {
                            headers: {
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                                'x-suppportcenter-token': Response.token,
                                'x-jichitai-jichitaiid': jichitaiId,
                                'x-jichitai-token': jichitaiToken,
                            },
                            params: {
                                supportedPersonId
                            }
                        })
                        .then(Common.handleErrors)
                        .then((response) => {
                            const res = response.getResponsibleKubunArray;
                            if (response.success) {
                                if (res.length === 0) {
                                    return;
                                } else {
                                    const categoryList = [];
                                    res.map((d) => {
                                        if(d.counselingKubunId !== '00' && d.counselingKubunId !== 'all'){
                                            const resObj = {
                                                categoryName: d.counselingKubunName,
                                                categoryId: d.counselingKubunId
                                            };
                                            categoryList.push(resObj);
                                        }
                                    });
                                    setCategoryList(categoryList);
                                }
                            } else {
                                window.alert(`code : [${response.type}]\nmessage : ${response.message}`);
                            }
                        })
                        .catch((err) => {
                            console.error('ChatUserSearch.js :get err:' + err.message);
                        });
                }
            })
            .catch((err) => {
                console.error('ChatUserSearch.js :get err:' + err.message);
            });
        }
    }

    function handleCategoryChange(counselingKubunId){
        if(counselingKubunId !== ''){
            setSelectCategory(counselingKubunId);
            const selectCategory = categoryList.filter((d) => d.categoryId === counselingKubunId);
            setDisplayCategory(selectCategory[0].categoryName);
        }
        else{
            setSelectCategory('');
            setDisplayCategory('');
        }
    }

    function handleStateChange(stateId){
        console.log(stateId);
        if(stateId !== ''){
            setState(stateId);
            const state = stateFlg.filter((d) => d.stateId === stateId);
            setDisplayState(state[0].stateName);
        }
        else{
            setState('');
            setDisplayState('');
        }
    }

    function handleStartDataChange(date){
        const dateArray = date.split('-');
        if(dateArray[0].length >= 5) {
            dateArray[0] = '9999';
            date = dateArray.join('-');
        }
        setRequsetStartDate(date);
    }

    function handleEndDataChange(date){
        const dateArray = date.split('-');
        if(dateArray[0].length >= 5) {
            dateArray[0] = '9999';
            date = dateArray.join('-');
        }
        setRequsetEndDate(date);
    }

    useEffect(() => {
        if(categoryList.length === 0) getChatData();
    },[categoryList]);

    return (
        <React.Fragment>
            <Typography className={classes.title} variant="h6" component="p">
                絞り込み条件設定
            </Typography>
            <Paper elevation={3} variant="outlined" className={classes.paper}>
                <div className={classes.topSpace}>
                    <FormGroup className={classes.selectKubunArea} row>
                        <Typography variant="body1" className={classes.labelArea}>
                                送信日：
                        </Typography>
                        <FormControl className={classes.dateSelectStart}>
                            <TextField
                                id="outlined-basic"
                                type="date"
                                variant="outlined"
                                className={classes.conditionLeft}
                                margin="normal"
                                value={requestStartDate}
                                onChange={(event) => handleStartDataChange(event.target.value)}
                            />
                        </FormControl>
                        <Typography className={classes.to} variant="h6" component="div">
                            {'～'}
                        </Typography>
                        <FormControl className={classes.dateSelectEnd}>
                            <TextField
                                id="outlined-basic"
                                type="date"
                                variant="outlined"
                                className={classes.conditionLeft}
                                margin="normal"
                                value={requestEndDate}
                                onChange={(event) => handleEndDataChange(event.target.value)}
                            />
                        </FormControl>
                    </FormGroup>
                    <FormGroup className={classes.selectKubunArea} row>
                        <Typography variant="body1" className={classes.labelArea}>
                            {`${kubunName}：`}
                        </Typography>
                            <React.Fragment>
                            <FormControl className={classes.categorySelect}>
                                {/* */}
                                <Select
                                    id="multiple-checkbox-johoKubun"
                                    value={displayCategory}
                                    className={classes.conditionLeft}
                                    variant="outlined"
                                >
                                    <MenuItem key={0} value={''} className={classes.stateList} onClick={() => handleCategoryChange('')}>{'選択なし'}</MenuItem>
                                    {categoryList.map((rec, i) => (
                                        <MenuItem key={i+1} value={rec.categoryName} onClick={() => handleCategoryChange(rec.categoryId)} className={classes.stateList}>
                                            {`${rec.categoryName}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </React.Fragment>
                    </FormGroup>
                    <FormGroup className={classes.selectKubunArea} row>
                        <Typography variant="body1" className={classes.labelArea}>
                                タイトル：
                        </Typography>
                        <FormControl className={classes.memo}>
                            <TextField
                                id="outlined-basic"
                                variant="outlined"
                                className={classes.conditionRight}
                                margin="normal"
                                value={chatTitle}
                                onChange={(event) => setChatTitle(event.target.value)}
                            />
                        </FormControl>
                    </FormGroup>
                    <FormGroup className={classes.selectKubunArea} row>
                        <Typography variant="body1" className={classes.labelArea}>
                                状態：
                        </Typography>
                        <FormControl className={classes.state}>
                            <Select
                                    id="multiple-checkbox-johoKubun"
                                    value={displayState}
                                    variant="outlined"
                                    className={classes.endFlg}
                                >
                                <MenuItem key={0} value={''} className={classes.stateList} onClick={() => handleStateChange('')}>{'選択なし'}</MenuItem>
                                {stateFlg.map((rec, i) => (
                                    <MenuItem key={i+1} value={rec.stateName} onClick={() => handleStateChange(rec.stateId)} className={classes.stateList}>{`${rec.stateName}`}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </FormGroup>
                    { availableAddress && (
                        <>
                            <FormGroup className={classes.selectKubunArea} row>
                                <Typography variant="body1" className={classes.labelArea}>
                                    {`${addressName}：`}
                                </Typography>
                                <FormControl className={classes.memo}>
                                    <TextField
                                        id="outlined-basic"
                                        variant="outlined"
                                        className={classes.conditionRight}
                                        margin="normal"
                                        value={addressNumber}
                                        onChange={(event) => setAddressNumber(event.target.value)}
                                    />
                                </FormControl>
                            </FormGroup>
                            <FormGroup className={classes.selectKubunArea} row>
                                <Typography variant="body1" className={classes.labelArea}>
                                    {`${userName}：`}
                                </Typography>
                                <FormControl className={classes.memo}>
                                    <TextField
                                        id="outlined-basic"
                                        variant="outlined"
                                        className={classes.conditionRight}
                                        margin="normal"
                                        value={nickName}
                                        onChange={(event) => setNickName(event.target.value)}
                                    />
                                </FormControl>
                            </FormGroup>
                        </>
                    )}
                    <FormGroup className={classes.button} row>
                        <SearchButton
                            chatTitle={chatTitle}
                            requestStartDate={requestStartDate}
                            requestEndDate={requestEndDate}
                            state={state}
                            counselingKubunId={selectCategory}
                            addressNumber={addressNumber}
                            nickName={nickName}
                            setData={setData}
                            setFullTextDisplayFlg={setFullTextDisplayFlg}
                            setIsLoading={setIsLoading}
                        />
                        <ResetButton
                            setTitle={setChatTitle}
                            setRequsetStartDate={setRequsetStartDate}
                            setRequsetEndDate={setRequsetEndDate}
                            setState={setState}
                            setSelectCategory={setSelectCategory}
                            setDisplayCategory={setDisplayCategory}
                            setAddressNumber={setAddressNumber}
                            setNickName={setNickName}
                            setData={setData}
                            setPage={setPage}
                            setDiaplayState={setDisplayState}
                            setFullTextDisplayFlg={setFullTextDisplayFlg}
                        />
                    </FormGroup>
                </div>
            </Paper>
        </React.Fragment>
    );
});

MessageLogSearch.propTypes = {
    classes: PropTypes.object.isRequired,
    setData: PropTypes.func.isRequired,
    setPage: PropTypes.func.isRequired,
    cookies: PropTypes.object.isRequired,
    availableAddress: PropTypes.bool.isRequired
};


export default withStyles(styles)(MessageLogSearch);